import React, { useEffect, useState, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import ProfileDropdown, {
  StudioDropdown,
} from "../ProfileDropdown/ProfileDropdown";
import "./Header.scss";
import { selectIcon, SVG } from "../UI/selector";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { profileActions } from "../../store";
import { getWhiteLabelData } from "../../services/Constants";
import { imageError } from "../../services/subscriberService";
import OutsideAlerter from "../UI/OutsideAlerter/OutsideAlerter";
import { ToastContainer, toast } from "react-toastify";
import { NotificationUI } from "../Notifications/Notification";
import { getApprovedGyms } from "../../services/CommonFunction";

const Header = ({
  showTitle = false,
  showLogo = true,
  title = "",
  showProfile = true,
}) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { approvedGyms, defaultGym } = useSelector(
    (state) => state.profile.profileData
  );
  const [isDropdownShowing, setDropDownStatus] = useState(false);
  const [isStudioDropdownShowing, setStudioDropDownStatus] = useState(false);

  const navLinks = [
    { label: "HOME", icon: "homeNav", route: "/Home" },
    {
      label: "LIVE & UPCOMNG",
      icon: "liveUpcomingNav",
      route: "/LiveAndUpcoming",
    },
    { label: "ONDEMAND", icon: "ondemandNav", route: "/OndemandScreen" },
    { label: "MY ACTIVITY", icon: "dumbellNav", route: "/MyActivity" },
    /* { label: "MY SCHEDULE", icon: "mySchedule", route: "/MySchedule" }, */
  ];

  const logout = () => {
    localStorage.removeItem("setId");
    localStorage.removeItem("accessToken");
    dispatch(profileActions.reset());
    history.push({ pathname: "/SignIn" });
  };

  const navigationHandler = (path) => {
    history.push({ pathname: `${path}` });
  };

  const navBar = navLinks.map((el, index) => (
    <div
      key={index}
      className={`tabDiv${el.route === location.pathname ? " active" : ""}`}
      onClick={() => navigationHandler(el.route)}
    >
      {el.route === location.pathname ? (
        <Fragment>
          <div className="activeDivCircle">
            <SVG src={selectIcon(el.icon)} />
          </div>
          <p>{el.label}</p>
          <div className="leftBorder"></div>
          <div className="rightBorder"></div>
        </Fragment>
      ) : (
        <SVG src={selectIcon(el.icon)} />
      )}
    </div>
  ));
  const { isWhiteLabeled, appName } = getWhiteLabelData();
  const new_approvedGyms = getApprovedGyms(approvedGyms);
  const logo = !isWhiteLabeled ? (
    <div className="studio">
      <OutsideAlerter clickOutSide={() => setStudioDropDownStatus(false)}>
        <div
          className={`nameAndProfile logo${
            new_approvedGyms.length > 1 ? " active" : ""
          }`}
          onClick={() => {
            if (new_approvedGyms.length > 1) {
              setStudioDropDownStatus(!isStudioDropdownShowing);
            }
          }}
        >
          <img
            className="profileImage"
            src={defaultGym ? defaultGym.logo_thumb : ""}
            onError={imageError}
            alt="logo"
          />
          <p>{defaultGym ? defaultGym.name : "Tribe"}</p>
          <FontAwesomeIcon
            className={new_approvedGyms.length === 1 ? "hidden" : ""}
            meta-id="user_profile_click"
            icon={faChevronDown}
          />
        </div>
        {isStudioDropdownShowing ? (
          <StudioDropdown
            meta_id="user_profile_click"
            closeDropdown={() =>
              setStudioDropDownStatus(!isStudioDropdownShowing)
            }
            gyms={new_approvedGyms}
          />
        ) : null}
      </OutsideAlerter>
    </div>
  ) : (
    <div className="logo_div">
      <img
        alt="logo"
        onClick={() => {
          history.push("/Home");
        }}
        onError={imageError}
      />
    </div>
  );

  return (
    <header>
      <div className="header_div">
        {showLogo ? logo : null}
        {showTitle ? (
          <div className={"HeaderTitle"}>{title}</div>
        ) : (
          <div className="tabsContainer">
            <div className="tabListDiv">
              {/* ============navbar============== */}
              {navBar}
              {/* ========navbar end============== */}
            </div>
          </div>
        )}

        {showProfile && (
          <div className="login_profile">
            <NotificationUI />
            {showProfile && (
              <OutsideAlerter clickOutSide={() => setDropDownStatus(false)}>
                <div
                  className="nameAndProfile active"
                  onClick={() => setDropDownStatus(!isDropdownShowing)}
                >
                  <img
                    className="profileImage"
                    src={localStorage.getItem("thumb")}
                    alt="logo"
                  />
                  <p>{localStorage.getItem("name")}</p>
                  <FontAwesomeIcon
                    meta-id="user_profile_click"
                    icon={faChevronDown}
                  />
                </div>
                {isDropdownShowing ? (
                  <ProfileDropdown
                    meta_id="user_profile_click"
                    logout={logout}
                    closeDropdown={() => setDropDownStatus(!isDropdownShowing)}
                  />
                ) : null}
              </OutsideAlerter>
            )}
          </div>
        )}
      </div>
      <ToastContainer /* autoClose={false}  transition={Slide}  */ />
    </header>
  );
};

export default Header;
